<app-background-animation></app-background-animation>
<div class="accept-invite-container">
    <div class="invite-card">
        <mat-card>
            <mat-card-header>
                <div class="rotating-logo"></div>
            </mat-card-header>
            <mat-card-content>
                <div>
                    <h2>404</h2>
                    <p>The page you were looking for couldn't be found.</p>
                </div>
            </mat-card-content>
            <mat-card-actions>
                <button mat-raised-button type="button" (click)="location.back()" color="primary">
                    Go Back
                </button>
            </mat-card-actions>
        </mat-card>
    </div>
</div>